import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #23272a;
  color: white;
`;

const Button = styled.button`
  margin: 10px;
  padding: 10px 20px;
  background-color: #7289da;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #5b6eae;
  }
`;

function AuthPage() {
  const navigate = useNavigate();

  const handleLogin = (user) => {
    localStorage.setItem('user', user); // Kullanıcı bilgisini sakla
    navigate('/main'); // Ana sayfaya yönlendir
  };

  return (
    <Container>
      <h1>Giriş Yap</h1>
      <Button onClick={() => handleLogin('User1')}>Kullanıcı 1 Olarak Giriş Yap</Button>
      <Button onClick={() => handleLogin('User2')}>Kullanıcı 2 Olarak Giriş Yap</Button>
    </Container>
  );
}

export default AuthPage;
